export function useFormattedNumber() {
  const formattedNumber = (value: number) => {
    if (!value) return ''
    return value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ' ')
  }
  return { formattedNumber }
}
